import React, { useEffect } from 'react';
import { useAdminRegistryState } from '@apps/registry/admin/state/context/AdminRegistry';
import { useAuth } from '@shared/components/AuthProvider';
import { RoutesPaths } from '@shared/core';
import { RoutesNames } from '@apps/registry/guest/GuestRegistry.routes';
import { useShoppingCart } from '../../../ShoppingCart/state';
import { useShoppingCartController } from '../../../ShoppingCart/ShoppingCart.controller';
import { ShoppingCartInnerV2 } from '../../../ShoppingCart/ShoppingCartInnerV2';

export const ShoppingCartTab: React.FC<{ eventId: string; eventHandle: string }> = ({ eventId, eventHandle }) => {
  const { registries, orders, registryCurrency } = useAdminRegistryState();
  const auth = useAuth();
  const {
    mutators: { updateDetails },
  } = useShoppingCart();
  useEffect(() => {
    if (auth.currentUser.profile?.email) {
      updateDetails({
        email: auth.currentUser.profile.email,
        message: '',
        name: [auth.currentUser.profile.firstName, auth.currentUser.profile.lastName].filter(Boolean).join(' '),
      });
    }
  }, [auth, updateDetails]);
  const {
    helpDialogOpen,
    productList,
    reservedOrderList,
    purchasedOrderList,
    orderCount,
    cartOrderCount,
    cartTotal,
    inCartProductList,
    inCartProductCount,
    inCartProductTotal,
    showHelpDialog,
    handleDialogClose,
  } = useShoppingCartController({
    registries,
    orders,
    registryCurrencyCode: registryCurrency?.code,
  });

  return (
    <ShoppingCartInnerV2
      eventHandle={eventHandle}
      eventId={eventId}
      helpDialogOpen={helpDialogOpen}
      productList={productList}
      reservedOrderList={reservedOrderList}
      purchasedOrderList={purchasedOrderList}
      inCartProductList={inCartProductList}
      inCartProductCount={inCartProductCount}
      inCartProductTotal={inCartProductTotal}
      orderCount={orderCount}
      cartOrderCount={cartOrderCount}
      cartTotal={cartTotal}
      paths={{} as RoutesPaths<RoutesNames>}
      hideCartHeader={true}
      showHelpDialog={showHelpDialog}
      handleDialogClose={handleDialogClose}
      registryCurrencyCode={registryCurrency?.code}
      isAddExternalOrderTrackingDialogOpen={false}
      orderForTrackingRequest={null}
      closeAddExternalOrderTrackingDialog={() => {}}
    />
  );
};
